import {
  ChildNotFoundError,
  ConnectionAlreadyRejectedError,
  NotifiedRecentlyError,
  ParentChildRelationshipAlreadyExistsError,
  ParentChildrenLimitExceededError,
  ParentNotFoundByCodeError,
  ParentNotFoundByUserIdError,
  UserNotAllowedToConnectToSelfError
} from "@seneca/parents-service-client";
import ChildToParentLimitExceededError from "@seneca/parents-service-client/out/errors/ChildToParentLimitExceededError";

export const ALREADY_LINKED_TO_PARENT = "You are already linked.";
export const PARENT_NOT_FOUND_BY_CODE =
  "Unable to find parent. Please make sure you have the correct code.";
export const PARENT_NOT_FOUND_BY_USER_ID =
  "Unable to find parent. Please refresh and try again.";
export const CHILD_NOT_FOUND =
  "Unable to find child. Please refresh and try again.";
export const CHILDREN_LIMIT_REACHED =
  "Your parent's account has reached the maximum number of linked children accounts.";

export const PARENT_LIMIT_REACHED =
  "You have reached the limit on the number of linked parent accounts.";
export const UNKNOWN_ERROR = "An unknown error has occurred.";

export const ATTEMPT_TO_CONNECT_TO_OWN_ACCOUNT =
  "Attempted to connect to own account";

export const NOTIFIED_PARENT_RECENTLY =
  "You've shared Premium with your parent too recently, please try again later";
export const CONNECTION_ALREADY_REJECTED =
  "Your parent has already rejected your invitation.";

export default function errorTranslator(error: Error): string {
  try {
    if (error instanceof ParentChildRelationshipAlreadyExistsError) {
      return ALREADY_LINKED_TO_PARENT;
    }

    if (error instanceof ParentNotFoundByCodeError) {
      return PARENT_NOT_FOUND_BY_CODE;
    }

    if (error instanceof ParentNotFoundByUserIdError) {
      return PARENT_NOT_FOUND_BY_USER_ID;
    }

    if (error instanceof ChildNotFoundError) {
      return CHILD_NOT_FOUND;
    }

    if (error instanceof ParentChildrenLimitExceededError) {
      return CHILDREN_LIMIT_REACHED;
    }

    if (error instanceof UserNotAllowedToConnectToSelfError) {
      return ATTEMPT_TO_CONNECT_TO_OWN_ACCOUNT;
    }

    if (error instanceof ChildToParentLimitExceededError) {
      return PARENT_LIMIT_REACHED;
    }

    if (error instanceof NotifiedRecentlyError) {
      return NOTIFIED_PARENT_RECENTLY;
    }

    if (error instanceof ConnectionAlreadyRejectedError) {
      return CONNECTION_ALREADY_REJECTED;
    }

    return UNKNOWN_ERROR;
  } catch (err: any) {
    return UNKNOWN_ERROR;
  }
}
